export default __webpack_public_path__ + "static/media/micOnNew.52762771.svg";